import { render, staticRenderFns } from "./SuitCell.vue?vue&type=template&id=4ab32f06&scoped=true&"
import script from "./SuitCell.vue?vue&type=script&lang=js&"
export * from "./SuitCell.vue?vue&type=script&lang=js&"
import style0 from "./SuitCell.vue?vue&type=style&index=0&id=4ab32f06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab32f06",
  null
  
)

export default component.exports